<template>
  <div>
    <div :class="topDividerClass"></div>
    <!-- user logged in template -->
    <div v-if="getIsUserLoggedIn">
      <!-- user can view cart buttons -->
      <div
        v-if="getBomCartButtonsAvailable"
        class="bomPriceAndCartBtns__cartBtns"
      >
        <div v-if="showPrices">
          <BomPriceTotal />
        </div>
        <BomCartButtons />
      </div>
      <!-- user needs to make more selections to view cart buttons -->
      <div v-else class="bomPriceAndCartBtns__finalizeOptions">
        Finalize options for total price
      </div>
    </div>
    <!-- user logged out template -->
    <div v-else class="bomPriceAndCartBtns__login">
      <legrandav-link
        label="Sign in"
        size="20px"
        @click="onLoginClick"
      ></legrandav-link>
    </div>
  </div>
</template>

<script>
import UtilityService from "../../../services/UtilityService";
import BomCartButtons from "./BomCartButtons";
import BomPriceTotal from "./BomPriceTotal";
import { mapGetters } from "vuex";

export default {
  props: {
    deviceType: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters("user", ["getIsUserLoggedIn"]),
    ...mapGetters("enhancedBom", [
      "getBomCartButtonsAvailable",
      "getHasFinishedBeenClicked"
    ]),
    ...mapGetters("enhancedproduct", ["showPrices"]),
    topDividerClass() {
      const baseClass = "bomPriceAndCartBtns__topDivider";
      if (true === this.getHasFinishedBeenClicked) {
        return baseClass;
      } else {
        return `${baseClass}-priceHidden`;
      }
    }
  },
  methods: {
    onLoginClick() {
      UtilityService.openSignInMenu();
      this.$store.dispatch("enhancedproduct/updateEnhancedLocalStorage");
    }
  },
  components: { BomCartButtons, BomPriceTotal }
};
</script>

<style lang="scss" scoped>
.bomPriceAndCartBtns {
  &__topDivider {
    border-top: 3px solid rgb(229, 229, 229);
    margin-top: 30px;
    &-priceHidden {
      margin-top: 30px;
      border-top: none;
    }
  }
  &__login {
    margin: 20px 0 10px;
    font-family: $font-family-sans-serif-medium;
    font-size: 24px;
    letter-spacing: 0.25px;
    text-align: left;
    a {
      color: $aqua;
      text-decoration: underline;
      cursor: pointer;
    }
    // @include media-breakpoint-up(sm) {
    //   font-size: 20px;
    // }
    // @include media-breakpoint-up(lg) {
    //   font-size: 24px;
    // }
  }
  &__finalizeOptions {
    margin-top: 20px;
    font-size: 24px;
    letter-spacing: 0.25px;
    font-family: $font-family-sans-serif-regular;
    text-align: left;
  }
  // temp remove
  &__finalizeOptionsPrice {
    margin: 20px 0;
    font-size: 24px;
    letter-spacing: 0.25px;
    font-family: $font-family-sans-serif-regular;
    text-align: left;
  }
  &__finalizeOptionsMsrp {
    font-size: 16px;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
    margin-bottom: 20px;
  }
  &____cartBtns {
    margin: 20px 0 30px 0;
  }
}
</style>
